import { ErrorResponse, httpClient } from '@/api/http-client'
import { FiscalNote, IssueFiscalNotePayload } from '@/types'
import {
  useMutation,
  UseMutationOptions,
  mutationOptions,
} from '@tanstack/react-query'

type IssueFiscalNoteParams = {
  companyKey: string
  fiscalNoteData: IssueFiscalNotePayload
}

export const issueFiscalNote = async ({
  companyKey,
  fiscalNoteData,
}: IssueFiscalNoteParams) => {
  const response = await httpClient('accounting-dealer').post(
    `/v3/fiscal-note/${companyKey}/issue`,
    fiscalNoteData,
    {
      ignoreErrorToast: true,
    },
  )
  return response.data
}

export const issueFiscalNoteOptions = () =>
  mutationOptions({
    mutationKey: ['issue-fiscal-note'],
    mutationFn: issueFiscalNote,
  })

export const useIssueFiscalNote = (
  options?: UseMutationOptions<
    FiscalNote,
    ErrorResponse,
    IssueFiscalNoteParams
  >,
) => {
  return useMutation({
    ...issueFiscalNoteOptions(),
    ...options,
  })
}
